/**
 * @class
 * @classdesc Model for DiscountCampaignRegistrant on DB
 * * */
export default class DiscountCampaignRegistrant {
  /**
   *Constructor - sets a model for whitelist user Data according to DB
   * @param {String} id
   * @param {Number} clientId
   * @param {Number} DiscountCampaignId
   * @param {Number} FreePassId
   * @param {String} phoneNumber
   * @param {String} carNumber
   * @param {String} name
   * @param {String} email
   * @param {String} comment
   * @param {String} registrationType
   * @param {String} status
   * @param {String} validFrom
   * @param {String} validTo
   * @param {Number} discountPercentage
   * @param {Number} discountCreditInCents
   * @param {Number} usedDiscountCreditInCents
   * @param {String} registeredAt
   * @param {String} inviteUuid
   * @param {String} inviteUrl
   */

  #DiscountCampaignRegistrantObject = {}

  constructor(
    id,
    discountCampaignId,
    freePassId,
    clientId,
    phoneNumber,
    carNumber,
    name,
    email,
    comment,
    registrationType,
    status,
    validFrom,
    validTo,
    discountPercentage,
    discountCreditInCents,
    usedDiscountCreditInCents,
    registeredAt,
    inviteUuid,
    inviteUrl
  ) {
    this.#DiscountCampaignRegistrantObject.Id = id || 0
    this.#DiscountCampaignRegistrantObject.DiscountCampaignId =
      discountCampaignId || 0
    this.#DiscountCampaignRegistrantObject.FreePassId = freePassId || 0
    this.#DiscountCampaignRegistrantObject.ClientId = clientId || null
    this.#DiscountCampaignRegistrantObject.PhoneNumber = phoneNumber || ''
    this.#DiscountCampaignRegistrantObject.CarNumber = carNumber || ''
    this.#DiscountCampaignRegistrantObject.Name = name || ''
    this.#DiscountCampaignRegistrantObject.Email = email || ''
    this.#DiscountCampaignRegistrantObject.Comment = comment || ''
    this.#DiscountCampaignRegistrantObject.RegistrationType =
      registrationType || 'MANUALLY_ADDED'
    this.#DiscountCampaignRegistrantObject.Status = status || ''
    this.#DiscountCampaignRegistrantObject.ValidFrom =
      validFrom || this.getValidFrom()
    this.#DiscountCampaignRegistrantObject.ValidTo =
      validTo || this.getValidTo()
    this.#DiscountCampaignRegistrantObject.DiscountPercentage =
      discountPercentage || null
    this.#DiscountCampaignRegistrantObject.DiscountCreditInCents =
      discountCreditInCents || null
    this.#DiscountCampaignRegistrantObject.UsedDiscountCreditInCents =
      usedDiscountCreditInCents || null
    this.#DiscountCampaignRegistrantObject.RegisteredAt = registeredAt || null
    this.#DiscountCampaignRegistrantObject.InviteUuid = inviteUuid || ''
    this.#DiscountCampaignRegistrantObject.InviteUrl = inviteUrl || ''
  }

  getValidFrom() {
    if (!this.validFrom) {
      return null
    }
    return this.validFrom
  }

  getValidTo() {
    if (!this.validTo) {
      return null
    }
    return this.validTo
  }

  /**
   * Get Whitelist Object
   * @return {Object} Whitelist Javascript object
   */
  getObject() {
    return this.#DiscountCampaignRegistrantObject
  }
}
